import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-user-logs-dialog',
  templateUrl: './user-logs-dialog.component.html',
  styleUrls: ['./user-logs-dialog.component.scss']
})
export class UserLogsDialogComponent implements OnInit {
  logDetails: any = [];
  constructor(
    public dialogRef: MatDialogRef<UserLogsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    // console.log(data);
    this.logDetails = data.logDetails;
   }

  ngOnInit() {
  }

  getObjectKey(obj) {
    return (Object.keys(obj))[0];
  }

  getObjectValue(obj) {
    return (Object.values(obj))[0];
  }

  isNotAnNumber(str) {
    return isNaN(str);
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/user-logs/user-logs-dialog/user-logs-dialog.component.ts